<script>
import Api from "api-client";
import BaseButton from "@/components/BaseButton.vue";

export default {
  name: "EmployeeDelete",

  components: { BaseButton },

  props: {
    employeeId: {
      required: true,
      type: String,
    },
    employeeName: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      deleteOpen: !this.isMobile(),
    };
  },

  methods: {
    isMobile() {
      return window.innerWidth <= 768;
    },

    deleteEmployee() {
      Api.deleteEmployee(this.employeeId)
          .then(() => {
            this.$toast.success({
              title: "Siker",
              message: "Sikeres törlés"
            });
            this.$router.push("/app/employee/list");
          })
          .catch(err => {
            console.error(err);
            this.$toast.error({
              title: "Hiba",
              message: "Api hiba",
            });
          });
    },
  },
}
</script>

<template>
  <div class="mt-3 pb-4 mb-4 font-jumper">
    <b-container
      fluid
      id="employee-delete-container"
      class="employee-delete pt-4 col-12"
    >
      <b-row>
        <b-col class="ml-0 profile-input-container" cols="12">
          <div class="employee-layout">
            <section
              class="employee-section-card"
              aria-label="Profil törlés"
            >
              <header class="employee-section-header">
                <h2
                  id="employee-delete-heading"
                  class="employee-section-title d-none d-md-block"
                >
                  Profil törlés
                </h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="employee-delete-panel"
                  :aria-expanded="String(deleteOpen)"
                  @click="deleteOpen = !deleteOpen"
                >
                  <span>Profil törlés</span>
                  <b-icon
                    :icon="deleteOpen ? 'chevron-up' : 'chevron-down'"
                    aria-hidden="true"
                  ></b-icon>
                </button>
              </header>

              <b-collapse
                id="employee-delete-panel"
                v-model="deleteOpen"
                class="employee-section-body"
              >
                <span class="employee-field-hint">
                  Amennyiben véglegesen törölni szeretnéd ezt a munkavállalói profilt, nyomd meg az alábbi gombot!
                </span>

                <div class="employee-form-actions">
                  <BaseButton
                    variant="danger"
                    label="Alkalmazotti profil törlése"
                    @click="() => {$bvModal.show('deleteModal');}"
                  />
                </div>
              </b-collapse>
            </section>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
        id="deleteModal"
        title="Törlés"
        hide-footer
    >
      <div class="employee-modal-text">
        Biztosan törölni akarod {{ employeeName }} alkalmazotti profilját?
      </div>

      <div class="employee-modal-actions mt-4">
        <BaseButton
            variant="danger"
            label="Nem"
            @click="$bvModal.hide('deleteModal')"
        />
        <BaseButton
            variant="success"
            label="Igen"
            @click="() => {
              $bvModal.hide('deleteModal');
              deleteEmployee();
            }"
        />
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.bold {
  font-weight: bold;
}

.hidden {
  display: none !important;
}

#employee-delete-container.employee-delete {
  color: #252734;
  padding-left: 0;
  padding-right: 0;
}

.employee-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.employee-section-card {
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.74);
  box-shadow: 0 20px 40px rgba(37, 39, 52, 0.08);
  padding: 28px;
}

.employee-section-header {
  margin-bottom: 18px;
}

.employee-section-title {
  color: #252734;
  font-family: JumperBold;
  font-size: 24px;
  line-height: 1.2;
  margin: 0;
}

.employee-section-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #252734;
  display: flex;
  font-family: JumperBold;
  font-size: 22px;
  justify-content: space-between;
  padding: 0;
  text-align: left;
  width: 100%;
}

.employee-section-toggle:focus {
  border-radius: 16px;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.7);
  outline: none;
}

.employee-field-hint {
  color: #252734;
  display: block;
  font-family: JumperThin;
  font-size: 12px;
  line-height: 1.25;
  margin-bottom: 4px;
  padding-left: 20px;
}

.employee-form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 18px;
}

.employee-modal-text {
  color: #252734;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  line-height: 1.4;
}

.employee-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

#employee-delete-container.employee-delete .row {
  margin-left: -8px;
  margin-right: -8px;
}

#employee-delete-container.employee-delete .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

#employee-delete-container.employee-delete .btn-light {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 999px !important;
  box-shadow: 0 8px 18px rgba(37, 39, 52, 0.08);
  display: inline-flex;
  justify-content: center;
  min-height: 38px;
}

#employee-delete-container.employee-delete .text-danger {
  color: #9f1d1d !important;
  font-size: 12px;
}

@media (min-width: 769px) {
  .employee-section-body.collapse:not(.show) {
    display: block !important;
    height: auto !important;
    visibility: visible !important;
  }
}

@media (max-width: 768px) {
  #employee-delete-container.employee-delete {
    padding-top: 16px !important;
  }

  .employee-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .employee-section-card {
    border-radius: 28px;
    padding: 20px;
  }

  .employee-form-actions,
  .employee-modal-actions {
    justify-content: flex-start;
  }
}
</style>
